import { render, staticRenderFns } from "./ClientNewInquiry.vue?vue&type=template&id=14c1ed94"
import script from "./ClientNewInquiry.vue?vue&type=script&lang=ts"
export * from "./ClientNewInquiry.vue?vue&type=script&lang=ts"
import style0 from "./ClientNewInquiry.vue?vue&type=style&index=0&id=14c1ed94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports